import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table
 *
 * Data containing coverage history.
 *
 * @param rows
 * @returns {Element}
 * @constructor
 */
export function Table({ rows = [] }) {
  /**
   * renderCoverageStatus
   *
   * display badge with active or inactive statuses.
   *
   * @param cell
   * @returns {Element}
   */
  const renderCoverageStatus = ({ cell }) => {
    if (cell?.value === true) {
      return (
        <Badge
          icon={<IconSymbol color="$success1" icon="check_circle" size="$sm" variant="filled" />}
          outline
          variant="success"
        >
          Active
        </Badge>
      );
    }

    if (cell?.value === false) {
      return (
        <Badge
          icon={<IconSymbol color="$error1" icon="remove_circle" size="$sm" variant="filled" />}
          outline
          variant="error"
        >
          Inactive
        </Badge>
      );
    }
  };

  /**
   * renderCoverageDate
   *
   * display date in MM/DD/YYYY format.
   *
   * @param cell
   * @returns {*}
   */
  const renderCoverageDate = ({ cell }) => {
    return dayjs(cell?.value).format('MM/DD/YYYY');
  };

  /**
   * renderCoverageCdb
   *
   * display CDB source.
   *
   * @param cell
   * @returns {string}
   */
  const renderCoverageCdb = ({ cell }) => {
    return String(cell?.value);
  };

  /**
   * renderCoverageLob
   *
   * display LOB source.
   *
   * @param cell
   * @returns {string}
   */
  const renderCoverageLob = ({ cell }) => {
    return String(cell?.value);
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return configuration?.initialColumns.map((item) => {
      const column = item;

      if (column.Header === 'Status') {
        column.Cell = renderCoverageStatus;
      }

      if (column.Header === 'Last Active Date') {
        column.Cell = renderCoverageDate;
      }

      if (column.Header === 'CDB') {
        column.Cell = renderCoverageCdb;
      }

      if (column.Header === 'LOB') {
        column.Cell = renderCoverageLob;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/CoverageStatus/components/Table/Table.jsx">
      <TableComponent
        {...{
          accessor: `eidSearch-coverageStatus`,
          columns,
          configuration,
          rows,
        }}
      />
    </ErrorHandler>
  );
}
